import { createContext, FC, ReactNode, useContext } from "react";
import { I_midmileTrip, I_vehicleTypeDic } from "./types";
import { useVehicles } from "./use-vehicles";

type I_Context = {
    fontSize:number,changeFontSize:(v:number)=>void,
    hub:{name:string,latitude:number,longitude:number}
    vehicleTypeDic:I_vehicleTypeDic,
    vehiclesHook:ReturnType<typeof useVehicles>,
    openDetaileModal:(row:I_midmileTrip)=>void,
    openReportModal:()=>void
}
const Context = createContext<I_Context>({} as any)
export const Provider:FC<{value:I_Context,children:ReactNode}> = ({value,children})=>{
    return <Context.Provider value={value}>{children}</Context.Provider>
} 
export const useProvider = ()=>useContext(Context)